const mediaItems = [
  {
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20behind%20the%20scenes%20film%20set%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20director%20and%20actors%20in%20period%20costumes%20discussing%20a%20scene%2C%20warm%20cinematic%20lighting%2C%20production%20atmosphere%2C%20movie%20making%20documentary%20style%2C%20no%20text_or_editing%20suite%20with%20timeline%20display&width=800&height=450&seq=tomato-media-01&orientation=landscape",
    title: '《锦绣芳华》幕后花絮独家曝光',
    desc: '导演携主创团队分享幕后故事',
    duration: '12:38',
    views: '126万',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20cozy%20studio%20setting%20with%20warm%20lighting%2C%20two%20comfortable%20armchairs%20facing%20each%20other%2C%20a%20small%20table%20with%20coffee%20cups%2C%20interview%20or%20podcast%20setup%2C%20intimate%20conversation%20atmosphere%2C%20cinematic%20warm%20tones%2C%20professional%20yet%20relaxed%20vibe%2C%20no%20text&width=800&height=450&seq=tomato-media-02&orientation=landscape",
    title: '追剧圆桌派：年度十佳剧集大讨论',
    desc: '资深剧评人深度解析年度好剧',
    duration: '28:15',
    views: '89万',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20split%20screen%20composition%20showing%20three%20different%20film%20genre%20scenes%20side%20by%20side%2C%20action%20sequence%20with%20dramatic%20lighting%2C%20romantic%20scene%20with%20soft%20tones%2C%20and%20mystery%20scene%20with%20moody%20shadows%2C%20cinematic%20montage%20style%2C%20warm%20color%20grading%2C%20no%20text&width=800&height=450&seq=tomato-media-03&orientation=landscape",
    title: '暑期档新剧速览：7月必看清单',
    desc: '一分钟看完本月所有重磅新剧',
    duration: '05:42',
    views: '203万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩片花
          </h2>
          <p className="text-sm text-foreground-600">幕后花絮、剧评解析与独家内容</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                  width="800"
                  height="450"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-600 mb-3">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>{item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>{item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}